import { render, staticRenderFns } from "./BacCustomers.vue?vue&type=template&id=17d336de&scoped=true&"
import script from "./BacCustomers.vue?vue&type=script&lang=ts&"
export * from "./BacCustomers.vue?vue&type=script&lang=ts&"
import style0 from "./BacCustomers.vue?vue&type=style&index=0&id=17d336de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d336de",
  null
  
)

export default component.exports